export default [
  {
    path: '/capacitacion_seleccion/campo',
    name: 'evaluacioncampo',
    component: () => import('@/views/configuracion/mantenimiento/capa_sele.vue'),
    meta: {
      pageTitle: 'Evaluación Liderazgo Campo',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Evaluación Liderazgo Campo',
          active: true,
        },
      ],
      resource: 'Evaluacion Campo',
      action: 'menu',
    },
  },
  {
    path: '/capacitacion_seleccion/packing',
    name: 'evaluacionpacking',
    component: () => import('@/views/configuracion/mantenimiento/capa_sele_packing.vue'),
    meta: {
      pageTitle: 'Evaluación Liderazgo en Packing',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Evaluación Liderazgo en Packing',
          active: true,
        },
      ],
      resource: 'Evaluacion Packing',
      action: 'menu',
    },
  },
  {
    path: '/capacitacion_plan_accion/packing',
    name: 'planaccionpacking',
    component: () => import('@/views/configuracion/mantenimiento/capa_sele_packing_accion.vue'),
    meta: {
      pageTitle: 'Plan Acción en Packing',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Plan Acción en Packing',
          active: true,
        },
      ],
      resource: 'Plan Accion Packing',
      action: 'menu',
    },
  },
  {
    path: '/capacitacion_plan_accion/campo',
    name: 'planaccioncampo',
    component: () => import('@/views/configuracion/mantenimiento/capa_sele_campo_accion.vue'),
    meta: {
      pageTitle: 'Plan Acción en Campo',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Plan Acción en Campo',
          active: true,
        },
      ],
      resource: 'Plan Accion Campo',
      action: 'menu',
    },
  },
  {
    path: '/capacitaciones',
    name: 'capacitaciones',
    component: () => import('@/views/capa_sele/capacitaciones_new.vue'),
    meta: {
      pageTitle: 'Capacitaciones',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Capacitaciones',
          active: true,
        },
      ],
      resource: 'Capacitaciones',
      action: 'menu',
    },
  },
  {
    path: '/capacitaciones/temas',
    name: 'temascapacitaciones',
    component: () => import('@/views/capa_sele/temas.vue'),
    meta: {
      pageTitle: 'Temas',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Temas',
          active: true,
        },
      ],
      resource: 'Temas Capacitaciones',
      action: 'menu',
    },
  },
  {
    path: '/capacitaciones/todos',
    name: 'todoscapacitaciones',
    component: () => import('@/views/capa_sele/todos.vue'),
    meta: {
      pageTitle: 'Todo',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Todo',
          active: true,
        },
      ],
      resource: 'Todo Capacitaciones',
      action: 'menu',
    },
  },
  {
    path: '/capacitaciones/graficos',
    name: 'graficoscapacitaciones',
    component: () => import('@/views/capa_sele/graficos.vue'),
    meta: {
      pageTitle: 'Gráficos',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Gráficos',
          active: true,
        },
      ],
      resource: 'Graficos Capacitaciones',
      action: 'menu',
    },
  },
  {
    path: '/capacitaciones/asistentes',
    name: 'asistentescapacitaciones',
    component: () => import('@/views/capa_sele/asistentes.vue'),
    meta: {
      pageTitle: 'Asistentes',
      breadcrumb: [
        {
          text: 'Capacitación y Entrenamiento',
        },
        {
          text: 'Asistentes',
          active: true,
        },
      ],
      resource: 'Asistentes Capacitaciones',
      action: 'menu',
    },
  },
  //-----------------------i
  {
    path: '/capa_sele/mantenedores/evaluador/capacitacion',
    name: 'evaluadorcapa',
    component: () => import('@/views/capa_sele/evaluadorcapa.vue'),
    meta: {
      pageTitle: 'Matenenedor Capacitacion',
      breadcrumb: [
        {
          text: 'Mantenedores',
          active:true,
        },
        {
          text: 'Capacitacion',
          active: true,
        },
      ],
      resource: 'Asistentes Capacitaciones',
      action: 'menu',
    },
  },

  //----------------------f


]
